import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { type DeviceTypeRecord } from "../DeviceTypeRecord";

import { deviceTypeQueryKeys } from "./deviceTypeQueryKeys";

/** Deletes a device type; fails with `RobotoConflictException` while devices are of it. */
export function useDeleteDeviceType() {
  const { deviceTypes } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeviceTypeRecord>({
    mutationFn: (deviceType) =>
      deviceTypes.deleteDeviceType(deviceType.device_type_id, {
        resourceOwnerId: deviceType.org_id,
      }),
    onSuccess: (_result, deviceType) => {
      void queryClient.invalidateQueries({
        queryKey: deviceTypeQueryKeys.list(deviceType.org_id),
      });
      // Dropped rather than invalidated: a refetch would only 404.
      queryClient.removeQueries({
        queryKey: deviceTypeQueryKeys.detail(deviceType.device_type_id),
      });
    },
  });
}
